import { cn } from '../../../utils/common-utils.ts';

interface IProps {
  className?: string;
}

const BluebookReferenceIcon = ({ className }: IProps) => (
  <svg
    aria-hidden="true"
    className={cn('h-[1.35rem] w-[1.35rem]', className)}
    fill="none"
    viewBox="0 0 24 24"
  >
    <rect
      height="15"
      rx="1.75"
      stroke="currentColor"
      strokeWidth="1.7"
      width="18"
      x="3"
      y="4.5"
    />
    <path
      d="M6.15 15.4L10 10.95"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.95"
    />
    <path
      d="M6.15 10.95L10 15.4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.95"
    />
    <path
      d="M13.65 8.35C13.65 7.22 14.54 6.4 15.7 6.4C16.8 6.4 17.62 7.12 17.62 8.06C17.62 8.82 17.22 9.32 16.55 9.82L14.5 11.3H17.83"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.65"
    />
  </svg>
);

export default BluebookReferenceIcon;
